interface CalendarDay {
  year: number;
  month: number;
  day: number;
}

const MS_PER_DAY = 86_400_000;
const CALENDAR_DAY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

function dayNumber(value: CalendarDay): number {
  return Date.UTC(value.year, value.month - 1, value.day) / MS_PER_DAY;
}

export function calendarDayCount(start: CalendarDay, end: CalendarDay): number {
  return Math.abs(dayNumber(end) - dayNumber(start)) + 1;
}

export function localCalendarDay(value: number | Date): CalendarDay {
  const date = value instanceof Date ? value : new Date(value);
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
}

export function calendarDayKey(value: number | Date | string): string {
  if (typeof value === "string") {
    const match = CALENDAR_DAY_PATTERN.exec(value);
    if (match) return match[0];
  }

  const { year, month, day } = localCalendarDay(
    value instanceof Date || typeof value === "number" ? value : new Date(value)
  );
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export function parseCalendarDayKey(value: string): Date {
  const match = CALENDAR_DAY_PATTERN.exec(value);
  if (!match) return new Date(value);
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

export function inclusiveLocalDayEnd(timestamp: number, maxTimestamp?: number): number {
  const date = new Date(timestamp);
  date.setHours(23, 59, 59, 999);
  return maxTimestamp == null ? date.getTime() : Math.min(date.getTime(), maxTimestamp);
}
